// frontend/src/components/Results/ResultsChart.js

import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const ResultsChart = ({ resultados }) => {
    // Filtrar solo pruebas de habilidad (TERMAN, OTIS) que tengan respuestas
    const pruebasHabilidad = resultados.filter(r => 
        (r.prueba_clave === 'TERMAN' || r.prueba_clave === 'OTIS') &&
        r.total_respondidas > 0
    );
    
    if (pruebasHabilidad.length === 0) {
        return null;
    }

    const data = {
        labels: pruebasHabilidad.map(r => r.prueba_nombre),
        datasets: [
            {
                label: 'Porcentaje de Aciertos',
                data: pruebasHabilidad.map(r => {
                    const total = parseInt(r.total_preguntas);
                    const correctas = parseInt(r.respuestas_correctas);
                    return total > 0 ? Math.round((correctas / total) * 100) : 0;
                }),
                backgroundColor: 'rgba(4, 131, 119, 0.8)',
                borderColor: 'rgba(4, 131, 119, 1)',
                borderWidth: 2,
                borderRadius: 8,
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Rendimiento en Pruebas de Habilidad',
                font: {
                    size: 16,
                    weight: 'bold'
                }
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        return `Porcentaje: ${context.raw}%`;
                    }
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                max: 100,
                title: {
                    display: true,
                    text: 'Porcentaje (%)'
                },
                grid: {
                    color: 'rgba(0, 0, 0, 0.1)'
                }
            },
            x: {
                title: {
                    display: true,
                    text: 'Pruebas'
                }
            }
        }
    };

    return (
        <div style={{ height: '400px', margin: '20px 0' , backgroundColor:'white', borderRadius:'16px'}}>
            <Bar data={data} options={options} />
        </div>
    );
};

export default ResultsChart;